/**
 * The remeda functions fail when there they are called with more arguments than expected.
 * It might be extremely annoying.
 *
 * Opposite of https://github.com/remeda/remeda/blob/main/src/purry.ts
 */
export function unpurry<TFunc extends (...args: ReadonlyArray<unknown>) => unknown>(fn: TFunc, count: number): TFunc {
	return ((...args) => {
		if (args.length === count) {
			return fn(...args);
		}

		if (args.length > count) {
			return fn(...args.slice(0, count));
		}

		const result = fn(...args) as TFunc;

		return (...next: ReadonlyArray<unknown>) => result(...next.slice(0, count - args.length));
	}) as TFunc;
}
